import styled from "styled-components";
import bannerBg from "../../../assets/WebsiteBuilder/bannerBg.jpg";

export const StyledWebsiteBuilders = styled.div`
    width: 100%;
    margin-bottom: 40px;
    .title {
        color: var(--text-color);
        font-size: 24px;
        line-height: 28px;
        font-weight: 400;
        margin-bottom: 15px;
    }
    .desc {
        color: rgba(119, 119, 119, 1);
        font-size: 18px;
        line-height: 22px;
        font-weight: 300;
        margin-bottom: 25px;
    }
    .head {
        border-radius: 20px;
        padding: 32px 20px;
        text-align: center;
        background-image: url(${bannerBg});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        margin-bottom: 44px;

        &::before {
            content: "";
            position: absolute;
            inset: 0;
            background: rgba(49, 49, 49, 0.9);
            z-index: 0;
            border-radius: 20px;
        }
        > * {
            position: relative;
            z-index: 1;
        }
        .label {
            display: block;
            color: var(--primary);
            font-size: 20px;
            line-height: 24px;
            font-weight: 400;
            margin-bottom: 15px;
        }
        .para {
            color: var(--white);
            font-size: 17px;
            line-height: 21px;
            font-weight: 300;
        }
    }
    .template-cards-wrap {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
        @media (min-width: 576px) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media (min-width: 768px) {
            grid-template-columns: repeat(3, 1fr);
        }
        @media (min-width: 1441px) {
            grid-template-columns: repeat(4, 1fr);
        }
    }
`;
